import { render, staticRenderFns } from "./ConsultRecord.vue?vue&type=template&id=9964903c"
import script from "./ConsultRecord.vue?vue&type=script&lang=js"
export * from "./ConsultRecord.vue?vue&type=script&lang=js"
import style0 from "./ConsultRecord.vue?vue&type=style&index=0&id=9964903c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports